import React from 'react';
import { motion } from 'framer-motion';
const pillars = ['Chat', 'Conexión', 'Cierre', 'Mentalidad', 'Estatus', 'Timing'];
const tomos = [{
  n: 1,
  title: 'Mentalidad del Hombre que Concreta',
  desc: 'El bloque mental que te frena antes de escribir el primer mensaje. Cómo eliminarlo y entrar al chat desde un lugar de valor real.'
}, {
  n: 2,
  title: 'El Perfil que Abre Puertas',
  desc: 'Tu identidad digital habla antes que vos. Cómo configurar fotos, bio y presencia para que ella sienta curiosidad antes del primer mensaje.'
}, {
  n: 3,
  title: 'Aperturas con Gancho Real',
  desc: 'Cómo romper el hielo de forma que genere respuesta inmediata. Sin "hola cómo va". Sin sonar igual a todos los demás.'
}, {
  n: 4,
  title: 'El Hilo que no Muere',
  desc: 'Técnicas para sostener el interés a lo largo de toda la conversación. Cómo evitar los silencios incómodos y mantener la dinámica viva.'
}, {
  n: 5,
  title: 'Conexión Profunda por Chat',
  desc: 'Cómo pasar de la charla superficial a algo que ella sienta como especial. El puente entre el interés y el deseo de verte en persona.'
}, {
  n: 6,
  title: 'Coqueteo con Medida',
  desc: 'El arte de picantear sin cruzar la línea. Cómo generar tensión agradable respetando el ritmo, sin sonar forzado ni básico.'
}, {
  n: 7,
  title: 'Lectura de Señales',
  desc: 'Cómo detectar en tiempo real si hay interés genuino o cortesía. Nunca más avanzar en el momento equivocado ni perderte la luz verde.'
}, {
  n: 8,
  title: 'El Cierre Natural',
  desc: 'Cómo proponer la salida de forma que el "sí" sea la respuesta lógica. Sin presión, sin quedar raro, sin el eterno "hablamos después".'
}, {
  n: 9,
  title: 'Manejo de Objeciones',
  desc: 'Qué hacer cuando aparece el "estoy ocupada" o el "hablamos después". Las respuestas exactas para no perder terreno y mantener el interés.'
}, {
  n: 10,
  title: 'Reactivación de Chats Fríos',
  desc: 'Cómo rescatar una conversación que se enfrió días o semanas atrás. El protocolo exacto para volver al radar sin quedar necesitado.'
}, {
  n: 11,
  title: 'Estatus y Valor Percibido',
  desc: 'Los hábitos invisibles que suben o destruyen tu valor por chat. Cómo proyectar la mejor versión de vos mismo en cada mensaje.'
}, {
  n: 12,
  title: 'El Protocolo Completo en Acción',
  desc: 'El capítulo de integración. Cómo aplicar todo el sistema de principio a fin en un chat real, con ejemplos completos y casos de uso.'
}];
export function Tomos() {
  return <section aria-label="Los 12 tomos" className="bg-ink" data-id="element-166" data-mp="2iw9f0xisvlxa">
      <div className="mx-auto max-w-6xl px-5 py-20 pb-[28px] pt-[4px]" data-id="element-167" data-mp="2ew8v4xcxmiiu">
        <div className="text-center pt-[14px]" data-id="element-168" data-mp="2soothkuw1sdf">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold" data-id="element-169" data-mp="2sqjf71dzhoik">
            🏆 Protocolo 3C™
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-white sm:text-4xl" data-id="element-170" data-mp="32mmjodwb5z8o">
            12 Tomos + 5 Bonos
          </h2>
          <p className="mt-2 text-base text-white/60" data-id="element-171" data-mp="2xokx3izobhsg">100+ páginas — Todo resuelto.</p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-172" data-mp="3h91yn7oaaxgr">
            {pillars.map(p => <span key={p} className="rounded-full border border-gold/30 bg-gold/10 px-3 py-1 text-xs font-bold uppercase tracking-wide text-gold" data-id="element-173" data-mp="3lbf3zuz4ctd0">
                {p}
              </span>)}
          </div>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-174" data-mp="3c95u97bod40o">
          {tomos.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06
        }} className="group rounded-2xl border border-white/10 bg-ink-2 p-5 transition-colors duration-200 hover:border-azul/50" data-id="element-175" data-mp="2xl2krnyfba74" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-176" data-mp="2en8idsrsvwxp">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-azul/20 font-display text-lg font-black text-azul-soft" data-id="element-177" data-mp="2jm31ywxldpiv">
                  {t.n}
                </span>
                <h3 className="text-sm font-bold leading-tight text-white" data-id="element-178" data-mp="3hx45qmvi1hub">{t.title}</h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-white/60" data-id="element-179" data-mp="3d5m4ryth7h9c">{t.desc}</p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}